<template lang="pug">
k-main.admin-program
  template( #title )
    .title
      h1.title {{ `Program: ${ postData.title.rendered }` }}
      k-actions.header-actions( :actions='actions' :icons='icons' )
  .main-content( v-bar )
    .inner
      section.objects.episodes( v-if='postData.collections.releases' )
        .header
          h2.title {{ episodesTitle }}
        .body
          k-admin-release.item(
            v-for='object in episodes'
            :object='object'
            :active='currentObject === object'
            :key='object.id'
            @focus='setCurrentObject'
          )
        .foooter
          .actions
      section.objects.archives( v-if='postData.collections.archives' )
        .header
          h2.title {{ archivesTitle }}
        .body
          k-admin-release.item(
            v-for='object in archives'
            :object='object'
            :active='currentObject === object'
            :key='object.id'
            @focus='setCurrentObject'
          )
        .foooter
          .actions
      template( v-if='post.objects' )
        section.objects( v-for='section in post.objects' )
          .header
            h2.title {{ section.title }}
          .body
            template( v-for='object in section.objects' )
              .item.denied(
                v-if='object.error_data'
                :key =`object.error_data.ach_access_denied &&
                  object.error_data.ach_access_denied.redirect`
              )
                i-lock.icon( title='Denied' )
                span.text Permission denied
              .item( v-else :key='object.id' )
                router-link.title(
                  :to='`/admin/content/program/object/${object.id}`'
                  v-html='object.title && object.title.rendered'
                )
          .foooter
            .actions
      k-actions.footer-actions(
        :actions='actions'
        :icons='icons'
        type='icon-text'
      )
</template>

<script lang="js">
import sortBy from 'lodash-es/sortBy'
import { mapState } from 'vuex'
import KActions from '@/blocks/k-actions'
// import KActionsIcons from '@/blocks/k-actions-icons'
import KAdminRelease from '@/blocks/k-admin-release'
import KMain from '@/blocks/k-main'
import WBtn from '@/widgets/w-btn'
import WBtnIcon from '@/widgets/w-btn-icon'
import ILock from 'icons/Lock'
import ILockOpen from 'icons/LockOpen'
import IVideo from 'icons/Video'
import ICart from 'icons/Cart'
import IChevronUp from 'icons/ChevronUp'
import IChevronDown from 'icons/ChevronDown'
import IDrag from 'icons/Drag'
import IAddPromo from 'icons/Filmstrip'
import IAddRelease from 'icons/VideoPlus'
import IAddArchive from 'icons/ArchiveArrowUp'
import IEditProgram from 'icons/PlaylistEdit'
import { preprocessActions } from '@/lib/util'

export default {
  name: 'AdminProgramPage',
  mixins: [],
  components: {
    KActions,
    // KActionsIcons,
    KAdminRelease,
    KMain,
    WBtn,
    WBtnIcon,
    ILock,
    ILockOpen,
    IVideo,
    ICart,
    IChevronUp,
    IChevronDown,
    IDrag,
    IAddPromo,
    IAddRelease,
    IAddArchive,
    IEditProgram,
  },
  props: {},
  data() {
    return {
      editing: false,
      currentObject: null,
      icons: {
        'lock': ILock,
        'lock-open': ILockOpen,
        'video': IVideo,
        'cart': ICart,
        'chevron-up': IChevronUp,
        // 'chevron-right': IChevronRight,
        'chevron-down': IChevronDown,
        'drag': IDrag,
        'add-promo': IAddPromo,
        'add-release': IAddRelease,
        'add-archive': IAddArchive,
        'edit-program': IEditProgram,
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    setCurrentObject( object ) {
      this.currentObject = object
    },
    doAction( action ) {
    },
  },
  computed: {
    ...mapState([ 'post' ]),
    postData() {
      return ( this.post && this.post.data ) || {}
    },
    promo_reel() {
      return this.postData.promo_reel || []
    },
    episodes() {
      return sortBy( this.postData.releases || [], 'release_number' )
    },
    episodesTitle() {
      return this.postData.title_releases || 'Programmes'
    },
    archives() {
      return this.postData.archives || []
    },
    archivesTitle() {
      return this.postData.title_archives || 'From the Archives'
    },
    actions() {
      return (
        this.post &&
           this.post.actions &&
           preprocessActions( this.post.actions, { item: this.postData })
      ) || {}
    },
  }
}
</script>

<style lang="scss">
.admin-program {
  --pad-item-info: 0;
  --pad-item-info-active: var(--s-xs) 0;
  section {
    > .body {
      > .item {
        > .title {
          background: rgba(0,0,0,0.03);
          font-size: var(--s-lg);
        }
        &:hover > .info, > .title:focus + .info {
          max-height: var(--s-2xl) !important;
        }
        margin-bottom: var(--s-3q);
      }
    }
  }
}
</style>
